import { ColumnViewModel } from '../../shared/column-types';

export const GENES_GDA_SUMMARY: ColumnViewModel = {
  columns: [
    'geneSymbol',
    'diseaseName',
    'diseaseUMLSCUI',
    'geneNcbiID',
    'geneEnsemblIDs',
    'numGenesAssociatedToDisease',
    'numVariantsAssociatedToDisease',
    'geneDPI',
    'geneDSI',
    'score',
    'sourceScore',
    'numPMIDsupportingAssociation',
    'numberChemsIncludedInEvidence',
    'numberPmidsWithChemsIncludedInEvidence',
    'numDBSNPsupportingAssociation',
    'yearInitial',
    'yearFinal',
    'EI',
    'EL',
    'diseaseType',
    'diseaseClassName_MSH',
    'diseaseClassName_UMLS',
    'diseaseClassName_DO',
    'diseaseClassName_HPO',
    'prevalence',
    'disease_inheritance',
    'geneNcbiType',
    'pathwayName',
    'pathwayID',
    'numCTs',
  ],
  defaultVisible: [
    'geneSymbol',
    'diseaseName',
    'numGenesAssociatedToDisease',
    'numVariantsAssociatedToDisease',
    'geneDPI',
    'geneDSI',
    'score',
    'sourceScore',
    'numPMIDsupportingAssociation',
    'numberChemsIncludedInEvidence',
    'numberPmidsWithChemsIncludedInEvidence',
    'numDBSNPsupportingAssociation',
    'yearInitial',
    'yearFinal',
    'EI',
    'diseaseType',
    'diseaseClassName_MSH',
    'numCTs',
  ],
};